<div class="page-title-area credencial-profile"
     *ngFor="let Image of bgImage;"
     style="background-image: url({{Image.background}});"
     translate="no">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li *ngFor="let route of routes">
                  <a routerLink="{{route.url}}">{{route.label}}</a>
                </li>
              </ul>
            <h2>Credencial Virtual</h2>
        </div>
    </div>
    <div class="shape9">
        <img src="assets/img/shape-signomedico.png"
             alt="image"
             width="10%" />
    </div>
</div>

<div class="user-actions col-sm-12 col-md-12 col-lg-12" translate="no">

    <div class="ptb-100">
        <div class="container">
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                    <div *ngIf="flagDataGecros"
                         class="credencial-image">
                        <div class="container col-lg-6 col-md-6 col-sm-6">
                            <p>
                                El uso de esta credencial es personal e intransferible. Deberá presentarse junto a un documento que acredite su identidad cada vez que se utilice el servicio. Deberá utilizarse dentro del período de vigencia.
                            </p>
                        </div>

                        <div class="container-credencial m-4">
                            <div class="sleeve">
                                <div class="credencial selected"
                                     *ngFor="let Image of bgImage"
                                     style="background-image: url({{Image.credencial}});">
                                    <div *ngIf="this.afiliadoFromGecros">
                                        <div class="datos-afiliado">
                                            <div class="numero-afiliado">
                                                <span>{{this.numeroAfiliado}}</span>
                                            </div>
                                        </div>
                                        <div class="credencial-expire">
                                            <span class="card-text">DNI:</span>
                                            {{this.afiliadoFromGecros?.documento}}
                                        </div>
                                        <div class="card-holder">
                                            <span class="card-text afiliado"
                                                  [ngStyle]="{'color': '#b71540'}">
                                                {{this.afiliadoFromGecros?.nombreAfiliado}}
                                            </span>
                                        </div>
                                        <div class="card-holder">
                                            <span class="card-text">PLAN:</span>
                                            {{this.afiliadoFromGecros?.plan || "No se encontró plan"}}
                                            <span class="card-text">OSOETSYLRA</span>
                                        </div>
                                        <span class="card-validez">
                                            VÁLIDO POR 24HRS  {{ this.currentDate }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="grupo-familiar">
                            <h2>Información General</h2>
                            <div class="callout"
                                 [ngClass]="{'callout-success': this.afiliadoFromGecros?.estado === estados[0], 'callout-danger': this.afiliadoFromGecros?.estado !== estados[0]}">
                                <div class="row">
                                    <div class="col">
                                        <h5>{{this.afiliadoFromGecros?.estado}}</h5>
                                        <h6>{{this.afiliadoFromGecros?.coberturas}}</h6>
                                    </div>
                                    <div class="col cobertura">
                                        <i *ngIf="this.afiliadoFromGecros?.estado === estados[0]"
                                           class="fas fa-check-circle fa-lg"
                                           style="color: #25fb09;"></i>
                                        <i *ngIf="this.afiliadoFromGecros?.estado !== estados[0]"
                                           class="fas fa-times-circle fa-lg"
                                           style="color: #f5220a;"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <small class="mb-3">Superintendencia de Servicios de Salud - Órgano de control 0800-222-SALUD (72583) - https://www.argentina.gob.ar/sssalud</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- cambie los translate aca tambien por las dudas -->

<!-- <div class="page-title-area credencial-profile"
     *ngFor="let Image of bgImage;"
     style="background-image: url({{Image.background}});">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li *ngFor="let route of routes">
                  <a routerLink="{{route.url}}">{{route.label}}</a>
                </li>
              </ul>
            <h2>Credencial Virtual</h2>
        </div>
    </div>
    <div class="shape9">
        <img src="assets/img/shape-signomedico.png"
             alt="image"
             width="10%" />
    </div>
</div>

<div class="user-actions col-sm-12 col-md-12 col-lg-12">

    <div class="ptb-100">
        <div class="container">
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                    <div *ngIf="flagDataGecros"
                         class="credencial-image">
                        <div class="container col-lg-6 col-md-6 col-sm-6">
                            <p>
                                El uso de esta credencial es personal e intransferible. Deberá presentarse junto a un documento que acredite su identidad cada vez que se utilice el servicio. Deberá utilizarse dentro del período de vigencia.
                            </p>
                        </div>

                        <div class="container-credencial m-4">
                            <div class="sleeve">
                                <div class="credencial selected"
                                     *ngFor="let Image of bgImage"
                                     style="background-image: url({{Image.credencial}});">
                                    <div *ngIf="this.afiliadoFromGecros">
                                        <div class="datos-afiliado">
                                            <div class="numero-afiliado">
                                                <span>{{this.numeroAfiliado}}</span>
                                            </div>
                                        </div>
                                        <div class="credencial-expire">
                                            <span class="card-text">DNI:</span>
                                            {{this.afiliadoFromGecros?.documento}}
                                        </div>
                                        <div class="card-holder">
                                            <span class="card-text afiliado"
                                                  [ngStyle]="{'color': '#b71540'}">
                                                {{this.afiliadoFromGecros?.nombreAfiliado}}
                                            </span>
                                        </div>
                                        <div class="card-holder">
                                            <span class="card-text">PLAN:</span>
                                            {{this.afiliadoFromGecros?.plan || "No se encontro plan"}}
                                            <span class="card-text"> OSOETSYLRA </span>
                                        </div>
                                        <span class="card-validez">
                                            VÁLIDO POR 24HRS  {{ this.currentDate }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="grupo-familiar">
                            <h2>Información General</h2>
                            <div class="callout"
                                 [ngClass]="{'callout-success': this.afiliadoFromGecros?.estado === estados[0], 'callout-danger': this.afiliadoFromGecros?.estado !== estados[0]}">
                                <div class="row">
                                    <div class="col">
                                        <h5>{{this.afiliadoFromGecros?.estado}}</h5>
                                        <h6>{{this.afiliadoFromGecros?.coberturas}}</h6>
                                    </div>
                                    <div class="col cobertura">
                                        <i *ngIf="this.afiliadoFromGecros?.estado === estados[0]"
                                           class="fas fa-check-circle fa-lg"
                                           style="color: #25fb09;"></i>
                                        <i *ngIf="this.afiliadoFromGecros?.estado !== estados[0]"
                                           class="fas fa-times-circle fa-lg"
                                           style="color: #f5220a;"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <small class="mb-3"> Superintendencia de Servicios de Salud - Órgano de control 0800-222-SALUD (72583) - https://www.argentina.gob.ar/sssalud </small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->